/* Generated. This file cannot be edited directly. Please check codegen.ts for configuration. */
// @ts-nocheck

import * as Apollo from '@apollo/client'

import { gql } from '@apollo/client'
import * as Types from '../../../../graphql/src/lib/graphql/generated/types'

const defaultOptions = {} as const
export type OperatingAreasByRegionIdQueryVariables = Types.Exact<{
  regionId: Types.Scalars['ID']['input']
}>

export type OperatingAreasByRegionIdQuery = {
  __typename?: 'Query'
  operatingAreasByRegionId: Array<{
    __typename?: 'OperatingArea'
    id: string
    name: string
    geometry: string
  }>
}

export const OperatingAreasByRegionIdDocument = gql`
    query operatingAreasByRegionId($regionId: ID!) {
  operatingAreasByRegionId(regionId: $regionId) {
    id
    name
    geometry
  }
}
    `

/**
 * __useOperatingAreasByRegionIdQuery__
 *
 * To run a query within a React component, call `useOperatingAreasByRegionIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useOperatingAreasByRegionIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOperatingAreasByRegionIdQuery({
 *   variables: {
 *      regionId: // value for 'regionId'
 *   },
 * });
 */
export function useOperatingAreasByRegionIdQuery(
  baseOptions: Apollo.QueryHookOptions<
    OperatingAreasByRegionIdQuery,
    OperatingAreasByRegionIdQueryVariables
  > &
    (
      | { variables: OperatingAreasByRegionIdQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    OperatingAreasByRegionIdQuery,
    OperatingAreasByRegionIdQueryVariables
  >(OperatingAreasByRegionIdDocument, options)
}
export function useOperatingAreasByRegionIdLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    OperatingAreasByRegionIdQuery,
    OperatingAreasByRegionIdQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    OperatingAreasByRegionIdQuery,
    OperatingAreasByRegionIdQueryVariables
  >(OperatingAreasByRegionIdDocument, options)
}
// @ts-ignore
export function useOperatingAreasByRegionIdSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    OperatingAreasByRegionIdQuery,
    OperatingAreasByRegionIdQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  OperatingAreasByRegionIdQuery,
  OperatingAreasByRegionIdQueryVariables
>
export function useOperatingAreasByRegionIdSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        OperatingAreasByRegionIdQuery,
        OperatingAreasByRegionIdQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  OperatingAreasByRegionIdQuery | undefined,
  OperatingAreasByRegionIdQueryVariables
>
export function useOperatingAreasByRegionIdSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        OperatingAreasByRegionIdQuery,
        OperatingAreasByRegionIdQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    OperatingAreasByRegionIdQuery,
    OperatingAreasByRegionIdQueryVariables
  >(OperatingAreasByRegionIdDocument, options)
}
export type OperatingAreasByRegionIdQueryHookResult = ReturnType<
  typeof useOperatingAreasByRegionIdQuery
>
export type OperatingAreasByRegionIdLazyQueryHookResult = ReturnType<
  typeof useOperatingAreasByRegionIdLazyQuery
>
export type OperatingAreasByRegionIdSuspenseQueryHookResult = ReturnType<
  typeof useOperatingAreasByRegionIdSuspenseQuery
>
export type OperatingAreasByRegionIdQueryResult = Apollo.QueryResult<
  OperatingAreasByRegionIdQuery,
  OperatingAreasByRegionIdQueryVariables
>
